<template>
    <div v-if="visible" class="addons-overlay">
        <div class="addons-dialog">

            <h2 class="title">เครดิตไม่เพียงพอ</h2>
            <p class="desc">คุณมีเครดิตไม่เพียงพอสำหรับ <strong>{{ featureName }}</strong></p>

            <div v-if="loading" class="loading">กำลังโหลดแพ็กเกจเครดิต...</div>

            <div v-else class="options-list">
                <div v-for="opt in options" :key="opt.amount" class="option-card">
                    <div class="option-info">
                        <div class="amount">เพิ่มเครดิต +{{ opt.amount }}</div>
                        <div class="price">฿{{ opt.price }}</div>
                    </div>
                    <button class="select-btn" @click="purchase(opt)">เติมเครดิต</button>
                </div>
            </div>

            <button class="close-btn" @click="close">ปิด</button>
        </div>
    </div>
</template>


<script>
import axios from "axios";

export default {
    data() {
        return {
            visible: false,
            fid: null,
            featureName: "ฟีเจอร์นี้",
            options: [],
            loading: false
        };
    },
    methods: {
        async open(fid) {
            this.visible = true;
            this.fid = fid;
            this.loading = true;

            try {
                const resp = await this.$http.get(
                    `${process.env.VUE_APP_BACKEND_URL}/api/subscription/addons/${fid}`,
                );
                this.featureName = resp.data.feature;

                this.options = resp.data.options;
            } finally {
                this.loading = false;
            }
        },
        close() {
            this.visible = false;
        },
        async purchase(opt) {
            const pageData = this.$storex.getters.getPageData;

            await this.$http.post(
                `${process.env.VUE_APP_BACKEND_URL}/api/subscription/addons/purchase`,
                { pageId: pageData.id, fid: this.fid, addonId: opt.addonId },
            );

            this.close();
            this.$emit("purchased"); // แจ้ง parent component ให้รีเฟรชเครดิต
        },
    }
};
</script>

<style scoped>
.addons-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .25);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.addons-dialog {
    background: #ffffff;
    border-radius: 16px;
    padding: 28px 24px;
    width: 380px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
    animation: fadeIn .25s ease-out;
    text-align: center;
}

.title {
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 6px;
}

.desc {
    color: #666;
    font-size: 14px;
    margin-bottom: 22px;
}

.options-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-bottom: 18px;
}

.option-card {
    border: 1px solid #e4e6eb;
    border-radius: 12px;
    padding: 14px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: border-color .2s;
}

.option-card:hover {
    border-color: #3461ff;
}

.option-info {
    text-align: left;
}

.amount {
    font-size: 15px;
    font-weight: 500;
    color: #2d3748;
}

.price {
    font-size: 14px;
    color: #5a5f68;
    margin-top: 2px;
}

.select-btn {
    padding: 6px 14px;
    border: none;
    background: #3461ff;
    color: #fff;
    font-size: 14px;
    border-radius: 8px;
    cursor: pointer;
    transition: background .2s;
}

.select-btn:hover {
    background: #274bdb;
}

.close-btn {
    background: transparent;
    border: none;
    color: #555;
    padding: 6px;
    cursor: pointer;
    font-size: 14px;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(6px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
